module.exports = __webpack_public_path__ + "static/atrevida-39324512b90b35e9894643229fa82280.jpg";